import script from "./ProductDetailPurchase.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetailPurchase.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetailPurchase.vue?vue&type=style&index=0&id=245a784e&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245a784e"]])

export default __exports__